/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Invite { 
    id: string;
    /**
     * A code which can be used to register to a campaign
     */
    code: string;
    /**
     * the date time until when the invite can be used to register to the campaign
     */
    expirationDate: string;
}

